<form [formGroup]="formGroup" *ngIf="showGroup" appPropagateSubmit [parentFormGroupDirective]="parentFormGroupDirective">
  <div *ngIf="title; then adresseTitle; else adresse"></div>
  <ng-template #adresseTitle>
    <div class="mt-3" [id]="idprefix + '_adresse'">
      <h6>{{ title }}</h6>
      <ng-template *ngTemplateOutlet="adresseTemplate"></ng-template>
    </div>
  </ng-template>
  <ng-template #adresse>
    <ng-template *ngTemplateOutlet="adresseTemplate"></ng-template>
  </ng-template>
  <ng-template #adresseTemplate>
    <div class="row">
      <div class="col col-xs-12 col-sm-9">
        <div class="input">
          <app-label [control]="strasse" class="input__label" [for]="idprefix + '_strasse'">Straße:</app-label>
          <mat-form-field>
            <input matInput [id]="idprefix + '_strasse'" maxlength="50" formControlName="strasse">
            <mat-error *ngIf="strasse.hasError('required')">{{ 'INPUTREQUIRED' | translate }}</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="col col-xs-12 col-sm-3">
        <div class="input">
          <app-label [control]="hausnummer" class="input__label" [for]="idprefix + '_hausnummer'">Haus Nr. :</app-label>
          <mat-form-field>
            <input matInput [id]="idprefix + '_hausnummer'" maxlength="35" formControlName="hausnummer">
            <mat-error *ngIf="hausnummer.hasError('required')">{{ 'INPUTREQUIRED' | translate }}</mat-error>
            <mat-error *ngIf="hausnummer.hasError('pattern')">{{ 'INPUTINVALID' | translate }}</mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col col-xs-12 col-sm-4">
        <div class="input">
          <app-label [control]="stiege" class="input__label" [for]="idprefix + '_stiege'">Stiege:</app-label>
          <mat-form-field>
            <input matInput [id]="idprefix + '_stiege'" maxlength="20" formControlName="stiege">
            <mat-error *ngIf="stiege.hasError('pattern')">{{ 'INPUTINVALID' | translate }}</mat-error>

          </mat-form-field>
        </div>
      </div>
      <div class="col col-xs-12 col-sm-4">
        <div class="input">
          <app-label [control]="stock" class="input__label" [for]="idprefix + '_stock'">Stock:</app-label>
          <mat-form-field>
            <input matInput [id]="idprefix + '_stock'" maxlength="20" formControlName="stock">
            <mat-error *ngIf="stock.hasError('pattern')">{{ 'INPUTINVALID' | translate }}</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="col col-xs-12 col-sm-4">
        <div class="input">
          <app-label [control]="tuernummer" class="input__label" [for]="idprefix + '_tuernummer'">Tür:</app-label>
          <mat-form-field>
            <input matInput [id]="idprefix + '_tuernummer'" maxlength="10" formControlName="tuernummer">
            <mat-error *ngIf="tuernummer.hasError('pattern')">{{ 'INPUTINVALID' | translate }}</mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col col-xs-12 col-sm-3">
        <div class="input">
          <app-label [control]="plz" class="input__label" [for]="idprefix + '_plz'">PLZ:</app-label>
          <mat-form-field>
            <input matInput [id]="idprefix + '_plz'" maxlength="10" formControlName="plz">
            <mat-error *ngIf="plz.hasError('required')">{{ 'INPUTREQUIRED' | translate }}</mat-error>
            <mat-error *ngIf="plz.hasError('pattern')">{{ 'INPUTINVALID' | translate }}</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="col col-xs-12 col-sm-9">
        <div class="input">
          <app-label [control]="ort" class="input__label" [for]="idprefix + '_ort'">Ort:</app-label>
          <mat-form-field>
            <input matInput [id]="idprefix + '_ort'" maxlength="50" formControlName="ort">
            <mat-error *ngIf="ort.hasError('required')">{{ 'INPUTREQUIRED' | translate }}</mat-error>
            <mat-error *ngIf="ort.hasError('pattern')">{{ 'INPUTINVALID' | translate }}</mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
  </ng-template>
</form>
